<div class="street-view-wrapper">
  <div #panorama class="street-view-container"></div>

  @if (status === 'cargando') {
    <div class="sv-overlay sv-cargando">
      <mat-spinner diameter="48" color="primary"></mat-spinner>
      <p>Buscando cobertura de Street View...</p>
    </div>
  }

  @if (status === 'no-disponible') {
    <div class="sv-overlay sv-sin-cobertura">
      <div class="sv-sin-cobertura-icon-wrap">
        <mat-icon class="sv-icon-base">streetview</mat-icon>
        <mat-icon class="sv-icon-slash">block</mat-icon>
      </div>
      <h3 class="sv-titulo">Sin cobertura</h3>
      <p class="sv-descripcion">
        Google Street View no tiene imágenes disponibles en esta ubicación.
      </p>
    </div>
  }

  @if (status === 'sin-coordenadas') {
    <div class="sv-overlay sv-sin-cobertura">
      <div class="sv-sin-cobertura-icon-wrap">
        <mat-icon class="sv-icon-base">location_off</mat-icon>
      </div>
      <h3 class="sv-titulo">Sin ubicación</h3>
      <p class="sv-descripcion">La alerta no tiene coordenadas asignadas.</p>
    </div>
  }
</div>
